import { useNavigate } from "react-router-dom";
import { MobileFrame } from "@/components/MobileFrame";
import { ReviewQueueSection } from "@/components/ReviewQueueSection";
import { useReviewPendingCount } from "@/hooks/useReviewPendingCount";

/** Standalone "To Review" page — lists completed verifications waiting on
 *  the user's keep/post/discard decision. Linked from the small tile on
 *  the Profile page. */
export default function Review() {
  const nav = useNavigate();
  const count = useReviewPendingCount();
  return (
    <MobileFrame>
      <div className="paper-bg" style={{ minHeight: "100vh", padding: "20px 0 80px" }}>
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", padding: "0 20px" }}>
          <h1 style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 26, margin: 0 }}>To review</h1>
          <button onClick={() => nav(-1)} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "monospace", fontSize: 11 }}>Close</button>
        </div>
        {count === 0 ? (
          <div style={{ padding: "60px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 40, lineHeight: 1, marginBottom: 14 }}>✦</div>
            <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 700, fontSize: 20, color: "hsl(var(--ink))", marginBottom: 6 }}>
              Nothing to review yet
            </div>
            <p style={{ fontFamily: "'Fraunces', 'Cormorant Garamond', serif", fontSize: 15, color: "hsl(var(--ink-2))", lineHeight: 1.4, maxWidth: 320, margin: "0 auto 18px" }}>
              Verified items waiting on a keep-or-post decision will land here. Run a verification to get started.
            </p>
            <button
              onClick={() => nav("/scan")}
              className="caps"
              style={{
                background: "hsl(var(--ink))", color: "hsl(var(--ink-fg))",
                border: "1px solid hsl(var(--ink))", padding: "10px 16px",
                cursor: "pointer", letterSpacing: "0.12em", fontSize: 11,
              }}
            >
              Verify an item →
            </button>
          </div>
        ) : (
          <ReviewQueueSection />
        )}
      </div>
    </MobileFrame>
  );
}